/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {
    ChooseSearchPayload,
    ClearSearchResultFeaturesPayload,
    CriteriaPayload,
    SearchParamPayload,
    SearchViewPayload,
} from './search.model';
import { DisplayFeaturePayload } from '../../map/state/active-map.model';
import { DisplayFeatureStateModifier } from '../../map/state/active-map.actions';
import { PagingOptionsPayload } from '../../../types/PagingOptions';

export class LoadSearches {
    static readonly type = '[Search] Load Searches';
}

export class ChooseSearch {
    static readonly type = '[Search] Choose Search';

    constructor(public payload: ChooseSearchPayload) {}
}

export class CancelChooseSearch {
    static readonly type = '[Search] Cancel choose search';
}

export class LoadSearchDefinitions {
    static readonly type = '[Search] Load search definitions';
}

export class SetSearchCriteria {
    static readonly type = '[Search] Set search criteria';

    constructor(public payload: CriteriaPayload) {}
}

export class SetSearchParams {
    static readonly type = '[Search] Set search params';

    constructor(public payload: SearchParamPayload) {}
}

export class SetSearchView {
    static readonly type = '[Search] Set search view';

    constructor(public payload: SearchViewPayload) {}
}

export class DisplaySearchResultFeatures implements DisplayFeatureStateModifier {
    static readonly type = '[Search] Display search result features';

    constructor(public payload: DisplayFeaturePayload) {}
}

export class ClearSearchResultFeatures {
    static readonly type = '[Search] Clear search result features from the map';

    constructor(public payload: ClearSearchResultFeaturesPayload) {}
}

export class SetSearchPagingOptions {
    static readonly type = '[Search] Set paging options';

    constructor(public payload: PagingOptionsPayload) {}
}

export class ResetSearchPagingOptions {
    static readonly type = '[Search] Reset paging options';

    constructor(public payload: { id: string }) {}
}
